import React, { useEffect, useRef, useState } from "react"

import { EarthIcon, FistIcon, SunIcon, WaterIcon } from "../assets/icons/ProgressBarIcons"
import { bountyTypesWithIconDataRef } from "../constants/datas"
import ButtonNew from "./ButtonNew"

const Checkbox = ({ checked }) => {
  if (!checked)
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M13.5711 3.99986V13.9999H3.57115V3.99986H13.5711ZM13.5711 2.57129H3.57115C2.78544 2.57129 2.14258 3.21415 2.14258 3.99986V13.9999C2.14258 14.7856 2.78544 15.4284 3.57115 15.4284H13.5711C14.3569 15.4284 14.9997 14.7856 14.9997 13.9999V3.99986C14.9997 3.21415 14.3569 2.57129 13.5711 2.57129Z" fill="#1A56DB" />
      </svg>
    )

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path d="M7.48186 11.8391L12.6426 6.66057L11.8747 5.89272L7.48186 10.3034L5.35686 8.17843L4.58901 8.94629L7.48186 11.8391ZM3.21401 15.4284C2.92829 15.4284 2.67829 15.3213 2.46401 15.107C2.24972 14.8927 2.14258 14.6427 2.14258 14.357V3.64272C2.14258 3.357 2.24972 3.107 2.46401 2.89272C2.67829 2.67843 2.92829 2.57129 3.21401 2.57129H13.9283C14.214 2.57129 14.464 2.67843 14.6783 2.89272C14.8926 3.107 14.9997 3.357 14.9997 3.64272V14.357C14.9997 14.6427 14.8926 14.8927 14.6783 15.107C14.464 15.3213 14.214 15.4284 13.9283 15.4284H3.21401Z" fill="#3F83F8" />
    </svg>
  )
}

const FilterDropdown = ({ onApply, selectedPrimary, label, options }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [showAll, setShowAll] = useState(false)
  const [selected, setSelected] = useState(selectedPrimary || ['All'])

  const wrapperRef = useRef(null)
  const panelRef = useRef(null)
  const buttonRef = useRef(null)

  const appliedCount = (selected?.[0] === `All` ? 0 : selected?.length || 0)
  const buttonLabel = appliedCount === 0 ? 'Filter' : appliedCount === 1 ? 'Filter Applied' : 'Filters Applied'

  useEffect(() => {
    setSelected(selectedPrimary || ['All'])
  }, [selectedPrimary])

  useEffect(() => {
    function handleDocClick(e) {
      const panel = panelRef.current
      const btn = buttonRef.current
      if (!panel || !btn) return
      if (panel.contains(e.target) || btn.contains(e.target)) return
      setIsOpen(false)
    }
    if (isOpen) document.addEventListener("mousedown", handleDocClick)
    return () => document.removeEventListener("mousedown", handleDocClick)
  }, [isOpen])

  const displayedOptions = showAll ? options : (options || []).slice(0, 6)
  const allLabel = `All`

  const handleToggle = () => setIsOpen(prev => !prev)

  const handleSelect = (name) => {
    if (name === allLabel) {
      setSelected([allLabel])
    } else {
      const newSelected = selected.includes(allLabel)
        ? [name]
        : selected.includes(name)
          ? selected.filter((item) => item !== name)
          : [...selected, name]
      setSelected(newSelected.length === 0 ? [allLabel] : newSelected)
    }
  }

  return (
    <div className="relative" ref={wrapperRef}>
      <button
        ref={buttonRef}
        onClick={handleToggle}
        className="relative  w-[10rem] border border-borderUnderline flex items-center justify-between gap-2 px-4 py-2 text-sm  text-textSecondary bg-grayBgNormal shadow-light-filter rounded-lg hover:bg-neutral50C transition-colors"
      >
        <span>{buttonLabel}</span>
        <span className="relative inline-block">
          <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M0.412691 2.53728L4.02209 5.24433C4.56559 5.65196 5.44356 5.65196 5.98706 5.24433L9.59646 2.53728C10.4605 1.87881 9.8473 0.75 8.60701 0.75L1.40214 0.75C0.147908 0.75 -0.465272 1.87881 0.412691 2.53728Z" fill="#969696" />
          </svg>
        </span>
      </button>

      {isOpen && (
        <div
          ref={panelRef}
          className="absolute right-0  w-[21.3125rem] bg-grayBgNormal border border-borderUnderline backdrop-blur-[62.5px]  rounded-md rounded-tr-none  z-40 p-4 flex flex-col gap-4 max-h-[38rem] overflow-y-auto"
        >
          <div className="flex-grow overflow-y-auto -mr-4 pr-4 space-y-4 scrollbar-hide">
            <div>
              <div className="text-base font-semibold text-textPrimary mb-[.375rem]">
                {label}
              </div>
              <ul className="flex flex-col gap-1">
                <li className="px-4 py-0 flex items-center gap-2 cursor-pointer" onClick={() => handleSelect(allLabel)}>
                  <Checkbox checked={selected.includes(allLabel)} />
                  <span className="font-normal text-tPrimary text-sm  tracking-[.018em] leading-5">All</span>
                </li>
                {displayedOptions.map((name) => (
                  <li key={name} className="px-4 py-0 flex items-center gap-2 cursor-pointer" onClick={() => handleSelect(name)}>
                    <Checkbox checked={selected.includes(name)} />
                    <span className="font-normal text-textPrimary text-sm tracking-[.018em] leading-5">{name}</span>
                  </li>
                ))}
                {options?.length > 6 && (
                  <button onClick={() => setShowAll(!showAll)} className="text-sm text-textSecondary  font-medium hover:underline mt-1 flex items-center gap-1 px-4">
                    <span>{showAll ? "Show less" : "Show more"}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={`transform transition-transform ${showAll ? "rotate-180" : ""}`}>
                      <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                  </button>
                )}
              </ul>
            </div>
          </div>

          <div className="mt-auto ">
            <ButtonNew
              type="button"
              fixedMinWidth={true}
              minWidthClass={"min-w-[100%]"}
              variant="blue"
              size="sm"
              onClick={() => {
                onApply(selected)
                setIsOpen(false)
              }}
            >
              Apply
            </ButtonNew>

          </div>
        </div>
      )}
    </div>
  )
}

export default FilterDropdown
